'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createPagedCollection;

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _bluebird = require('bluebird');

var _utils = require('../utils');

var _serverErrors = require('../serverErrors');

var _PagedCollectionState = require('./PagedCollectionState');

var _PagedCollectionState2 = _interopRequireDefault(_PagedCollectionState);

var _urlUtils = require('../urlUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _auroraJavascriptUtils.log.getLogger('rpc');

function navigation2Query(navigation) {
    var result = '';

    result = result + ('page=' + navigation.pageNumber);

    if (navigation.pageSize) {
        result = result + ('&size=' + navigation.pageSize);
    }

    navigation.sort.forEach(function (order) {
        result = result + ('&sort=' + order.property + ',' + order.direction); // todo(FVENDOR-5227): add support for other features - nulls, ...
    });

    return result;
}

function parameters2Query(parameters) {
    if (parameters.getQueryPart) {
        return parameters.getQueryPart();
    }

    var attributes = _underscore2.default.extend({}, parameters.attributes);
    delete attributes.id;

    return (0, _urlUtils.hash2query)(attributes);
}

/**
 * create new paged collection for specific hateoas-model
 */
function createPagedCollection(Model, superAgent, collectionUrl) {
    return Model.Collection.extend({
        hateoasModel: Model,

        initialize: function initialize(models, options) {
            var _this = this;

            this._navigation = options.navigation;
            this._parameters = options.parameters;
            this._additionalInfo = options.additionalInfo;
            this._state = new _PagedCollectionState2.default();

            this.listenTo(this._navigation, 'change', function () {
                return _this._reset(false);
            });
            this.listenTo(this._parameters, 'change', function () {
                return _this._reset(true);
            });

            var releaseCallback = options.releaseCallback;

            this._refereceCounter = new _auroraJavascriptUtils.ReferenceCounter(0, function () {
                _this.stopListening(_this._navigation, 'change');
                _this.stopListening(_this._parameters, 'change');
                releaseCallback();
            });
        },
        sync: function sync(method, collection, options) {
            var _this2 = this;

            if (method !== 'read') {
                throw new Error('unsupported sync type \'' + method + '\'');
            }

            var syncPromise = _bluebird.Promise.resolve().then(function () {
                if (!_this2._isValidRequestModels()) {
                    throw new Error('request models not valid');
                } else {
                    return superAgent.get(_this2._getUrl()).then(_utils.checkHttpCode).then(function (superAgentResponse) {
                        var response = superAgentResponse.body;

                        // reference models are not supported, use SimpleModel manually
                        if (response.additionalInfo) {
                            collection._additionalInfo.set(response.additionalInfo);
                        }

                        return (0, _utils.normalizeModels)(_this2.hateoasModel.domain, _this2.hateoasModel.hateoasType, response, superAgent).then(function (models) {
                            return { models: models, superAgentResponse: superAgentResponse };
                        });
                    });
                }
            }).then(function (_ref) {
                var models = _ref.models,
                    superAgentResponse = _ref.superAgentResponse;

                options.success(models);
                _this2._state._syncCompleteSuccess(superAgentResponse);
                _this2.trigger(_this2.triggerWhenChanged);
                return superAgentResponse;
            }, function (errResp) {
                logger.error(errResp.message);
                (0, _serverErrors.applyServerErrorsIfAccepted)(_this2._parameters, errResp);
                _this2._state._syncCompletedWithError(errResp);
                _this2.trigger(_this2.triggerWhenChanged);
                options.error(errResp);
            });

            this._state._startSync(syncPromise);

            return (0, _utils.promise2jqueryPromise)(syncPromise);
        },
        close: function close() {
            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (delay) {
                this._refereceCounter.releaseWithDelay(delay);
                return;
            }

            this._refereceCounter.release();
        },
        _isValidRequestModels: function _isValidRequestModels() {
            return this._navigation.isValid() && this._parameters.isValid();
        },
        _getUrl: function _getUrl() {
            var navigationQueryPart = navigation2Query(this._navigation);
            var parametersQueryPart = parameters2Query(this._parameters);

            return collectionUrl + '?' + navigationQueryPart + parametersQueryPart;
        },
        getState: function getState() {
            return this._state;
        },
        getParameters: function getParameters() {
            return this._parameters;
        },
        getNavigation: function getNavigation() {
            return this._navigation;
        },
        getAdditionalInfo: function getAdditionalInfo() {
            return this._additionalInfo;
        },


        // todo(FVENDOR-5227): review
        reload: function reload() {
            this._reset();
        },
        _reset: function _reset(goToFirstPage) {
            if (goToFirstPage) {
                this._navigation.set('pageNumber', 0, { silent: true });
            }

            this._state.set({
                totalPages: 0,
                totalElements: 0
            });

            this.fetch();
        }
    }, {
        hateoasModel: Model
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/paged/pagedCollectionFactory.js
// module id = 1418
// module chunks = 118